module.exports = __webpack_public_path__ + "img/logo-bni-qris.db658dca.webp";